/* eslint-disable @typescript-eslint/naming-convention */
export enum FacewashFunction {
	"洗顔機能のみの商品",
	"メイク落とし機能のみの商品",
	"洗顔～メイク落としまでできる商品（ダブル洗顔不要）",
	"その他",
}
